export const contractInitialValues = {
  nuProcesso:'',
  nuProcessoSei:'',
  cdTipoContrato:'',
  cdOrgao:'',
  cdTipoServico:'',
  deRazaoSocial:'',
  nuTermo:'',
  dtAssinatura:null,
  nuPrazo:'',
  deTipoPrazo:'anos',
  cdPermissionarioRefData:'',
  dtInicioVigencia:null,
  dtVencimento:null,
  dtPublicacao:null,
  deObservacao:'',
};















